(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_1cbb8db"] && !Shopify.designMode) return;
  try {
    (() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pause = ms => new Promise(resolve => window.setTimeout(resolve, ms));

  const mount = root => {
    if (root.dataset.aiHeroReady) return;
    const letters = root.querySelector('[data-ai-hero-letters]');
    const source = root.querySelector('[class*="ai-hero-phrases-"]');
    if (!letters || !source) return;
    const phrases = Array.from(source.children, item =>
      Array.from(item.textContent.trim().replace(/\.\s*$/, ''))
    );
    if (!phrases.length) return;
    root.dataset.aiHeroReady = 'true';
    const stop = root.querySelector('[data-ai-hero-stop]');
    if (stop) {
      const syncStop = () => {
        stop.hidden = /[,.!?]$/.test(letters.textContent.trimEnd());
      };
      new MutationObserver(syncStop).observe(letters, { childList: true, characterData: true, subtree: true });
      syncStop();
    }
    if (motion.matches) {
      letters.textContent = phrases[0].join('');
      return;
    }

    const run = async () => {
      while (root.isConnected) {
        for (const phrase of phrases) {
          if (!root.isConnected || motion.matches) {
            if (root.isConnected) letters.textContent = phrases[0].join('');
            return;
          }
          letters.textContent = '';
          await pause(280);
          for (let count = 1; count <= phrase.length; count++) {
            if (!root.isConnected) return;
            letters.textContent = phrase.slice(0, count).join('');
            await pause(55);
          }
          await pause(1800);
          for (let count = phrase.length - 1; count >= 0; count--) {
            if (!root.isConnected) return;
            letters.textContent = phrase.slice(0, count).join('');
            await pause(55);
          }
        }
      }
    };
    run();
  };

  const mountAll = context => {
    context.querySelectorAll('[data-ai-hero-typewriter]').forEach(mount);
  };
  mountAll(document);
  document.addEventListener('shopify:section:load', event => mountAll(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
